import VmaForm from "../VmaForm"
import ContactForm from "./ContactForm"

const FORMS = {
  contact: ContactForm,
  vma: VmaForm,
}

const FormBlock = ({ data, content }) => {
  const Variant = FORMS[data.form_type?.value] ?? FORMS.contact

  return <Variant data={data} content={content} />
}

export default FormBlock
